import { ReactNode } from 'react';
import styled from 'styled-components';
import { Flex } from 'reflexbox';

import PlainHorizontalCard, {
	PlainHorizontalCardPadding,
} from 'packages/kakapo-ui-kit/components/cards/PlainHorizontalCard';
import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import Button, { ButtonSize } from '../editors/Button';

interface IProps {
	children?: ReactNode;
	title: string;
	backgroundColor?: string;
	button?: { title: string; onClick: () => void };
	buttonComplement?: ReactNode;
}

const Element = styled.div`
	img {
		width: 400px;
		max-width: 100%;
	}
`;

export default function EmptyStateCard({ children, title, backgroundColor, button, buttonComplement }: IProps) {
	return (
		<PlainHorizontalCard
			padding={PlainHorizontalCardPadding.Large}
			backgroundColor={backgroundColor}
		>
			<Element>
				<Flex alignItems="center" flexDirection="column">
					{children && <Column py={2}>{children}</Column>}

					<Column p={3} textAlign="center">
						<SectionTitle>{title}</SectionTitle>
					</Column>

					{button && (
						<Column p={3} textAlign="center" style={{ position: 'relative' }}>
							<Button size={ButtonSize.Medium} onClick={button.onClick}>
								{button.title}
							</Button>
							{buttonComplement}
						</Column>
					)}
				</Flex>
			</Element>
		</PlainHorizontalCard>
	);
}
